import { useRef } from "react";
import Label from "../../../../../components/label/Label";
import { Editor } from "react-draft-wysiwyg";
import { generateJsonFromHTML } from "../../../../../util/generateHTMLfromJSON";

const ProposalDescription = ({ fromTalent, client, proposalData }) => {
    const styleMap = useRef({});

    return (
        proposalData?.proposalDescription?.length > 0 && (
            <div
                className={
                    fromTalent && !client
                        ? "freelancerModalComponentWrap ml-0"
                        : "freelancerModalComponentWrap"
                }
            >
                <Label
                    label={
                        proposalData?.talentName
                            ? `Why ${proposalData.talentName}`
                            : "Proposal Description"
                    }
                    className="font18Black boldFont sectionTitleWrapper"
                />
                <div>
                    <Editor
                        editorState={generateJsonFromHTML(
                            proposalData.proposalDescription,
                            styleMap
                        )}
                        readOnly={true}
                        customStyleMap={styleMap.current}
                        toolbarClassName={"d-none"}
                    />
                </div>
            </div>
        )
    );
};

export default ProposalDescription;
